"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_addons_1 = require("./repeater/repeater-addons");
var repeater_utils_1 = require("./repeater/repeater-utils");
var EpsilonFieldRepeater = /** @class */ (function () {
    /**
     * Object constructor
     * @param control
     */
    function EpsilonFieldRepeater(control) {
        /**
         * Rows
         * @type {Array}
         */
        this.rows = [];
        /**
         * Current index
         */
        this.currentIndex = 0;
        this.control = control;
        this.context = control.container;
        this.utils = this.loadUtils();
        this.template = this.loadTemplate();
        /**
         * Create a reference of the container
         */
        this.repeaterContainer = this.getRepeaterContainer();
        /**
         * Setting field reference
         */
        this.settingField = this.context.find('[data-customize-setting-link]');
        /**
         * Setup Limit
         *
         * @type {boolean}
         */
        if (!_.isUndefined(this.control.params.choices.limit)) {
            this.limit = (0 >= this.control.params.choices.limit) ? false : parseInt(this.control.params.choices.limit);
        }
        /**
         * Handle events
         */
        this.handleEvents();
        /**
         * Create the existing rows
         */
        this.createExistingRows();
        /**
         * Make rows sortable
         */
        this.initSortable();
    }
    /**
     * Repeater container
     * @returns {any}
     */
    EpsilonFieldRepeater.prototype.getRepeaterContainer = function () {
        return this.context.find('.repeater-fields');
    };
    /**
     * Load utilities
     * @public
     */
    EpsilonFieldRepeater.prototype.loadUtils = function () {
        return new repeater_utils_1.EpsilonRepeaterUtils(this);
    };
    /**
     * Load template
     */
    EpsilonFieldRepeater.prototype.loadTemplate = function () {
        return this.utils.repeaterTemplate();
    };
    /**
     * Create existing rows
     */
    EpsilonFieldRepeater.prototype.createExistingRows = function () {
        var control = this;
        if (this.control.params.value.length) {
            for (var i = 0; i < this.control.params.value.length; i++) {
                var row = void 0, addons = void 0;
                row = control.utils.add(this.control.params.value[i]);
                addons = new repeater_addons_1.EpsilonRepeaterAddons(control, row);
                addons.initPlugins();
            }
        }
    };
    /**
     * Handle click/saving/etc events
     */
    EpsilonFieldRepeater.prototype.handleEvents = function () {
        var self = this;
        /**
         * 1. Add row button
         */
        this.context.on('click', 'button.epsilon-repeater-add', function (e) {
            var newRow, addons;
            e.preventDefault();
            if (!self.limit || self.currentIndex < self.limit) {
                newRow = self.utils.add();
                addons = new repeater_addons_1.EpsilonRepeaterAddons(self, newRow);
                addons.initPlugins();
            }
            else {
                jQuery(self.control.selector + ' .limit').addClass('highlight');
            }
        });
        /**
         * 2. REMOVE Row button
         */
        this.context.on('click', '.repeater-row-remove', function (e) {
            self.handleRowDecrementor();
            if (!self.limit || self.currentIndex < self.limit) {
                jQuery(self.control.selector + ' .limit').removeClass('highlight');
            }
        });
    };
    /**
     * Initiate sortable functionality
     */
    EpsilonFieldRepeater.prototype.initSortable = function () {
        var control = this;
        this.repeaterContainer.sortable({
            handle: '.repeater-row-header',
            axis: 'y',
            distance: 15,
            stop: function (e, data) {
                setTimeout(control.utils.sort(data), 200);
            },
        });
    };
    /**
     * Handles row addition
     */
    EpsilonFieldRepeater.prototype.handleRowIncrementor = function () {
        /**
         * Update index;
         */
        this.currentIndex++;
    };
    /**
     * Handles row addition
     */
    EpsilonFieldRepeater.prototype.handleRowDecrementor = function () {
        /**
         * Update index;
         */
        this.currentIndex--;
    };
    return EpsilonFieldRepeater;
}());
exports.EpsilonFieldRepeater = EpsilonFieldRepeater;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/repeater.ts
// module id = 6
// module chunks = 0